import type { PropsWithChildren } from 'react';
import { cn } from '../../../utils/cn';

type Options = {
  className?: string;
};

export default function ContentContainer({
  className,
  children,
}: PropsWithChildren<Options>) {
  return (
    <div className={cn('container py-20 max-sm:py-10', className)}>
      {children}
    </div>
  );
}
